import { configureStore } from '@reduxjs/toolkit';
import {
  authMiddleware,
  cartMiddleware,
  variationMiddleware,
  identifierMiddleware,
  identifierReducer,
  variationReducer,
} from '@amzn/d2c-application-website-common';
import authReducer from 'src/store/authSlice';
import merchReducer from 'src/store/merchSlice';
import catalogReducer from 'src/store/catalogSlice';
import cartReducer from 'src/store/cartSlice';
import templateReducer from 'src/store/templateSlice';

const safeParse = (key: string) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : undefined;
  } catch (e) {
    console.error(`Failed to parse ${key} from localStorage:`, e);
    return undefined;
  }
};

const loadPersistedState = () => {
  const authState = safeParse('authState');
  const cartState = safeParse('cartState');
  const variationState = safeParse('variationState');
  const identifierState = safeParse('identifierState');

  return {
    ...(authState && { auth: authState }),
    ...(cartState && { cart: { ...cartReducer(undefined, { type: '' }), cart: cartState } }),
    ...(variationState && { variation: variationState }),
    ...(identifierState && { identifier: { sessionId: identifierState } }),
  };
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    merch: merchReducer,
    catalog: catalogReducer,
    cart: cartReducer,
    variation: variationReducer,
    identifier: identifierReducer,
    template: templateReducer,
  },
  preloadedState: loadPersistedState(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authMiddleware,
      cartMiddleware,
      variationMiddleware,
      identifierMiddleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
